module.exports = __webpack_public_path__ + "5c114213/img/lock-icon.bb9c7166.svg";